import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {DISP_MODE, OPERATING_ENVIRONMENT_URLS, URL_PARAMS} from "../../../../constants/constants";

export interface WorldDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  worldId: string,
}

export function WorldDetailDialog(props: WorldDetailDialogProps) {
  const params = new URLSearchParams();
  params.append(URL_PARAMS.DISP_MODE, DISP_MODE.POPUP);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='ワールド詳細'
                  src={`${OPERATING_ENVIRONMENT_URLS.WORLD_DETAIL.URL}/${props.worldId}?${params.toString()}`}/>
  )
}
